import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_SUBSCRIPTION',
  name: 'Workspace Subscription',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
